module.exports = __webpack_public_path__ + "static/media/logo.d1b20b57.png";